import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IProjectPhaseProfileMetadata {
  collapsedState: Record<number, Record<number, boolean>>;
}

const initialState: IProjectPhaseProfileMetadata = {
  collapsedState: {},
};

export const projectPhaseProfileMetadataSlice = createSlice({
  name: 'projectPhaseProfileMetadata',
  initialState,
  reducers: {
    setProjectPhaseProfileCollapsedState: (
      state,
      action: PayloadAction<{
        projectId: number;
        collapsedState: Record<number, boolean>;
      }>
    ) => {
      const { projectId, collapsedState } = action.payload;

      state.collapsedState[projectId] = collapsedState;
    },

    updateProjectPhaseCollapsedState: (
      state,
      action: PayloadAction<{
        projectId: number;
        phaseId: number;
        isCollapsed: boolean;
      }>
    ) => {
      const { projectId, phaseId, isCollapsed } = action.payload;

      if (!state.collapsedState[projectId]) {
        state.collapsedState[projectId] = {};
      }

      state.collapsedState[projectId][phaseId] = isCollapsed;
    },
  },
});

export const { setProjectPhaseProfileCollapsedState, updateProjectPhaseCollapsedState } =
  projectPhaseProfileMetadataSlice.actions;

export default projectPhaseProfileMetadataSlice.reducer;
